import { createElementBlock as e, openBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function h(n, a) {
  return l(), e("svg", t, a[0] || (a[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.002 2a1 1 0 0 0-2 0v.5h-.666a3 3 0 0 0-3 3v1.026A4 4 0 0 0 3.794 10.5v10H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-.85v-10a4 4 0 0 0-3.48-3.967V5.5a3 3 0 0 0-3-3h-.668zm1.667 5.046V5.5a1 1 0 0 0-1-1h-3.333a1 1 0 0 0-1 1v1h2.636a1 1 0 0 1 0 2H7.794a2 2 0 0 0-2 2v10H9.17v-.833a2.833 2.833 0 1 1 5.667 0v.833h3.313v-10a2 2 0 0 0-2-2h-.59a1 1 0 0 1-.89-1.454m-6.333 3.37a1 1 0 1 0 0 2h1.833a1 1 0 0 0 0-2zm0 3.266a1 1 0 1 0 0 2h1.833a1 1 0 1 0 0-2zm2.834 5.985a.833.833 0 0 1 1.667 0v.833H11.17zm1.666-8.25a1 1 0 0 1 1-1h1.833a1 1 0 1 1 0 2h-1.833a1 1 0 0 1-1-1m0 3.265a1 1 0 0 1 1-1h1.833a1 1 0 1 1 0 2h-1.833a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const v = { render: h };
export {
  v as default,
  h as render
};
//# sourceMappingURL=ic_hotel-DIAdZDZO.js.map
